<mat-form-field [appearance]="appearance" fxFlex>
  <input type="text" [placeholder]="placeholder" aria-label="Number" matInput
  [matAutocomplete]="auto" [(ngModel)]="AutoValue" (ngModelChange)="this.autoUpdate.next($event)">
  <mat-autocomplete #auto="matAutocomplete" (optionSelected)="valueChanged()">
      <mat-option *ngFor="let option of options | async" [value]="option.value">
          {{option.value}}
      </mat-option>
  </mat-autocomplete>
</mat-form-field>
